import axios from "axios";
import { apiCall } from "@/common/api/ApiResult.model";

// https://dev.azure.com/shieldox/X2O/_wiki/wikis/Justification%20Request%20Api/345/README

import {
  JustificationRequest,
  Justification,
  JustificationQueryParams,
  JustificationTableItemHelper,
  JustificationTableItem,
} from "./model";
import { to_query_params } from "@/utils/url";
import { SharedState } from "@/common/state";
import { gql2 } from "@/gql/lib";
import { Event } from "@/gql/types";

export const get_justification_email_body = apiCall<
  string,
  {
    success: boolean;
    request: JustificationRequest;
    content: string;
    subject: string;
    reason: string;
  }
>("justification.body", async (event_id) => {
  const res = await axios.get(
    `/justification/request/generate/event/${event_id}`
  );
  return {
    success: true,
    value: res.data,
  };
});

export const send_justification = apiCall<
  { event_id: string; justification: JustificationRequest },
  boolean
>("justification.send", async ({ justification, event_id }) => {
  const res = await axios.post(
    `/justification/request/send/event/${event_id}`,
    justification
  );
  return {
    success: true,
    value: res.data,
  };
});

export const send_updated_justification = apiCall<
  {
    event_id: string;
    request: JustificationRequest;
    content: string;
    subject: string;
  },
  string
>("justification.send", async ({ request, content, event_id, subject }) => {
  const res = await axios.post(
    `/justification/request/send/event/${event_id}`,
    {
      request,
      content,
      subject,
    }
  );
  return {
    success: true,
    value: res.data.id,
  };
});

export const get_justifications = apiCall<
  { cursor: string; params: JustificationQueryParams },
  { cursor: string; values: JustificationTableItem[] }
>("justification.list", async ({ params, cursor: old_cursor }) => {
  const qparams = old_cursor ? `cursor=${old_cursor}` : to_query_params(params);
  const res = await axios.get(`/justification/find?${qparams}`);
  const { results, cursor } = res.data;
  const mapper = JustificationTableItemHelper.from_justification(
    SharedState.admins.value
  );
  return {
    success: true,
    value: {
      cursor,
      values: results.map(mapper),
    },
  };
});

export const get_justification_by_id = apiCall<string, Justification>(
  "justification.one",
  async (justification_id) => {
    const res = await axios.get(`/justification/id/${justification_id}`);
    return {
      success: true,
      value: res.data,
    };
  }
);
